<template>
    <v-form-element v-bind="$props">
        <textarea
            ref="textarea"
            :id="id"
            :type="type"
            :class="className + ' ' + defaultHeight"
            :placeholder="getPlaceholder()"
            v-model="model"
            :required="required"
            :disabled="disabled"
            @input="onInput"
            @click="$emit('click')"
            @hover="$emit('hover')"
            @blur="$emit('blur')"
            @focus="$emit('focus')"
        ></textarea>
    </v-form-element>
</template>

<script>

    import FormElement from './Element';
    import mixin from './mixin';

    export default {
        components: {
            'v-form-element': FormElement
        },
        mixins: [mixin],
        props: {
            shouldResize: {
                type: Boolean,
                default: false
            },
            defaultHeight: {
                type: String,
                default() {
                    if ( this.shouldResize ) {
                        return '';
                    }
                    return 'h-32';
                }
            }
        },
        methods: {
            onInput(event) {
                this.$emit('input');

                this.resize();
            },
            resize()
            {
                if ( ! this.shouldResize ) {
                    return;
                }
                this.$refs.textarea.style.height = "auto";
                this.$refs.textarea.style.height = `${this.$refs.textarea.scrollHeight}px`;
            }
        },
        mounted() {
            if ( this.shouldResize ) {
                this.$nextTick(() => {
                    this.resize();
                });
            }
        }
    }
</script>
